export const apiBodyConstructorForDashboard = (
  startTime,
  endTime,
  binSize,
  authToken,
  dgname,
  siteName,
  orgName
) => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: {
      startTime: `${startTime}`,
      endTime: `${endTime}`,
      dgname: `${dgname}`,
      siteName: `${siteName}`,
      org_name: `${orgName}`,
      binSize: `${binSize}`,
    },
  };
};

export const apiBodyConstructorForDashboardCS = (
  startTime,
  endTime,
  binSize,
  authToken,
  dgname,
  siteName,
  orgName
) => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: {
      startTime: `${startTime}`,
      endTime: `${endTime}`,
      dgname: `${dgname}`,
      siteName: `${siteName}`,
      org_name: `${orgName}`,
      binSize: `${binSize}`,
    },
  };
};

export const apiBodyConstructorForCurrentStats = (
  authToken,
  dgname,
  siteName,
) => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: {
      groupName: `${dgname}`,
      siteName: `${siteName}`,
    },
  };
};

export const apiBodyConstructorForCurrentStatsCS = (
  authToken,
  orgName,
  dgname,
  siteName,
) => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: {
      org_name: `${orgName}`,
      groupName: `${dgname}`,
      siteName: `${siteName}`,
    },
  };
};
